<script setup lang="ts">
import screenshots from '~/assets/screenshots/tasks/config?screenshots';

const getImage = useImage();
const { t } = useI18n();

const IMAGES: {
  id: number;
  src: string;
  class?: string;
  alt: string;
}[] = [
  {
    id: 229,
    class: 'sm:block hidden',
    alt: t('list.0.alt'),
  },
  {
    id: 99,
    alt: t('list.1.alt'),
  },
  {
    id: 971,
    alt: t('list.2.alt'),
  },
  {
    id: 961,
    class: 'sm:block hidden',
    alt: t('list.3.alt'),
  },
  {
    id: 621,
    class: 'xl:hidden md:block hidden',
    alt: t('list.4.alt'),
  },
  {
    id: 6,
    class: 'md:block hidden',
    alt: t('list.5.alt'),
  },
  {
    id: 1133,
    alt: t('list.6.alt'),
  },
  {
    id: 1010,
    class: 'md:block hidden',
    alt: t('list.7.alt'),
  },
  {
    id: 1040,
    class: 'sm:block hidden',
    alt: t('list.8.alt'),
  },
].map((el) => ({
  ...el,
  src: getImage(screenshots[el.id], { format: 'webp' }),
}));
</script>

<template>
  <section class="p-section pt-20 pb-16 bg-surface-700">
    <h2 class="text-3xl md:text-5xl text-800 text-center mt-0 mb-8">
      {{ t('title') }}
    </h2>
    <div
      class="lg:container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
    >
      <div
        data-show-on-visible
        class="bg-surface-800 shadow-2 rounded-lg p-3"
        v-for="image in IMAGES"
        :key="image.src"
        :class="image.class"
        style="border-radius: 6px"
      >
        <Image
          :src="image.src"
          :alt="image.alt"
          class="w-full !block aspect-screenshot"
          preview
          :preview-button-props="{ 'aria-label': t('zoom_image_button') }"
          :pt="{ image: { class: 'w-full object-cover', loading: 'lazy' } }"
        />
      </div>
    </div>
  </section>
</template>

<i18n>
en:
  title: What does the game look like
  zoom_image_button: Zoom image
  list:
    - alt: Kiss her on the lips until the timer goes off, in the process you can caress her neck and hair with your hands.
    - alt: Squat in front of the girl and gently run over her leg as in the photo. Through jeans is also considered to be
        done.
    - alt: Put your hand in her panties and play with her pussy for 2 minutes.
    - alt: She lies on her stomach with her legs spread wide. Give her a gentle massage of the buttocks, thighs and lower
        back.
    - alt: She is on her knees, resting her hands on the wall or headboard. You stand next to her and start kissing her on the
        lips while caressing her pussy with your hand.
    - alt: Lie on your back on the bed. Let her sit on your face with her pussy and drive her clit over your lips
    - alt: Get on your knees with your back to your boyfriend. Bend harder back, and in order not to fall, lean on your legs.
        At this time, the guy will approach you and start having sex with your throat, inserting the dick as deep as
        possible. Relax your throat so that when the guy moves, the dick protrudes freely through the throat.
    - alt: She lies on her back and puts her legs on your shoulders. Love her as deeply and strongly as you can.
    - alt: Your girlfriend in a knee-elbow position, lie down on the sheet with your chest, you slowly move in her pussy for 2
        minutes.

ru:
  title: Как выглядит игра
  zoom_image_button: Увеличить изображение
  list:
    - alt: Целуй ее в губы пока не сработает таймер, в процессе можешь ласкать руками ее шею и волосы.
    - alt: Присядь перед девушкой и нежно проведи по ее ноге как на фото. Через джинсы тоже считается что выполнил.
    - alt: Засунь руку в её трусики и поиграй с её киской 2 минуты.
    - alt: Она ляжет на живот, широко раздвинув ноги. Сделай ей нежный массаж ягодиц, бедер и поясницы.
    - alt: Она стоит на коленях, уперевшись руками на стену или спинку кровати. Ты встаешь сбоку от неё и начинаешь целовать
        её в губы, одновременно лаская её киску рукой.
    - alt: Ляг на спину на постель. Пусть она сядет тебе киской на лицо и водит своим клитором по твоим губам
    - alt: Встань на колени спиной к своему парню. Выгнись сильнее назад, а чтобы не упасть оперись на свои ноги. В это время
        парень приблизится к тебе и начнет заниматься сексом с твоим горлом вставляя член как можно глубже. Расслабь
        свое горло, чтобы при движениях парня член свободно выпирал сквозь горло.
    - alt: Она ляжет на спину и закинет ноги тебе на плечи. Люби её так глубоко и сильно, как можешь.
    - alt: Твоя девушка в коленно-локтевой позе ложиться грудью на простынь, ты медленно двигаешься в её киске 2 минуты.

de:
  title: Wie das Spiel aussieht
  zoom_image_button: Bild vergrößern
  list:
    - alt: Küssen Sie sie auf die Lippen, bis der Timer abläuft, und streicheln Sie dabei mit Ihren Händen ihren Hals und ihre
        Haare.
    - alt: Setzen Sie sich vor das Mädchen und reiben Sie sanft ihr Bein, wie auf dem Foto. Durch Jeans wird auch davon
        ausgegangen, dass er es geschafft hat.
    - alt: Stecken Sie Ihre Hand in ihr Höschen und spielen Sie zwei Minuten lang mit ihrer Muschi.
    - alt: Sie wird mit weit gespreizten Beinen auf dem Bauch liegen. Massieren Sie ihr sanft das Gesäß, die Oberschenkel und
        den unteren Rücken.
    - alt: Sie kniet und stützt ihre Hände auf die Wand oder das Kopfteil. Du stehst neben ihr und küsst sie auf die Lippen,
        während du mit deiner Hand ihre Muschi streichelst.
    - alt: Legen Sie sich mit dem Rücken auf das Bett. Lass sie mit ihrer Muschi auf deinem Gesicht sitzen und ihre Klitoris
        über deine Lippen reiben
    - alt: Gehen Sie mit dem Rücken zu Ihrem Freund auf die Knie. Beugen Sie sich weiter nach hinten und stützen Sie sich auf
        Ihre Beine, um Stürze zu vermeiden. Zu diesem Zeitpunkt wird der Kerl auf Sie zukommen und beginnen, Sex mit
        Ihrer Kehle zu haben, indem er seinen Penis so tief wie möglich einführt. Entspannen Sie Ihren Hals, sodass der
        Penis frei durch den Hals ragt, wenn sich der Mann bewegt.
    - alt: Sie wird auf dem Rücken liegen und ihre Beine über deine Schultern werfen. Liebe sie so tief und stark wie du
        kannst.
    - alt: Dein Mädchen liegt in einer Knie-Ellenbogen-Position mit der Brust auf dem Laken, du bewegst dich 2 Minuten lang
        langsam in ihrer Muschi.

es:
  title: Cómo se ve el juego
  zoom_image_button: Ampliar imagen
  list:
    - alt: Bésala en los labios hasta que suene el cronómetro y en el proceso podrás acariciarle el cuello y el cabello con
        las manos.
    - alt: Siéntate frente a la niña y frota suavemente su pierna como en la foto. A través de los jeans también se considera
        que lo ha completado.
    - alt: Pon tu mano en sus bragas y juega con su coño durante 2 minutos.
    - alt: Ella se acostará boca abajo con las piernas bien abiertas. Dale un suave masaje en las nalgas, muslos y zona
        lumbar.
    - alt: Está de rodillas, apoyando las manos en la pared o en la cabecera. Te paras junto a ella y comienzas a besarla en
        los labios, mientras acaricias su coño con la mano.
    - alt: Acuéstese boca arriba en la cama. Déjala sentarse en tu cara con su coño y frota su clítoris en tus labios.
    - alt: Ponte de rodillas de espaldas a tu novio. Inclínate más hacia atrás y apóyate en las piernas para evitar caer. En
        este momento, el chico se acercará a ti y comenzará a tener sexo con tu garganta, introduciendo su pene lo más
        profundo posible. Relaje la garganta para que cuando el chico se mueva, el pene sobresalga libremente por la
        garganta.
    - alt: Ella se acostará boca arriba y echará las piernas sobre tus hombros. Ámala tan profunda y fuertemente como puedas.
    - alt: Tu chica se acuesta en posición de rodillas y codos con el pecho sobre la sábana, te mueves lentamente en su coño
        durante 2 minutos.

fr:
  title: A quoi ressemble le jeu
  zoom_image_button: Agrandir l'image
  list:
    - alt: Embrassez-la sur les lèvres jusqu'à ce que le minuteur sonne et, ce faisant, vous pourrez caresser son cou et ses
        cheveux avec vos mains.
    - alt: Asseyez-vous devant la fille et frottez-lui doucement la jambe comme sur la photo. Grâce au jean, on considère
        également qu'il l'a terminé.
    - alt: Mettez votre main dans sa culotte et jouez avec sa chatte pendant 2 minutes.
    - alt: Elle s'allongera sur le ventre, les jambes écartées. Faites-lui un léger massage sur les fesses, les cuisses et le
        bas du dos.
    - alt: Elle est à genoux et pose ses mains sur le mur ou la tête de lit. Vous vous tenez à côté d'elle et commencez à
        l'embrasser sur les lèvres, tout en lui caressant la chatte avec votre main.
    - alt: Allongez-vous sur le dos sur le lit. Laissez-la s'asseoir sur votre visage avec sa chatte et frottez son clitoris
        sur vos lèvres
    - alt: Mettez-vous à genoux, dos à votre petit ami. Penchez-vous davantage en arrière et appuyez-vous sur vos jambes pour
        éviter de tomber. À ce moment-là, le mec s'approchera de vous et commencera à avoir des relations sexuelles avec
        votre gorge, en insérant son pénis le plus profondément possible. Détendez votre gorge pour que lorsque l'homme
        bouge, le pénis dépasse librement de la gorge.
    - alt: Elle s'allongera sur le dos et jettera ses jambes sur vos épaules. Aimez-la aussi profondément et fortement que
        possible.
    - alt: Votre fille est allongée en position genou-coude avec la poitrine sur le drap, vous bougez lentement dans sa chatte
        pendant 2 minutes.
</i18n>
